import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "49.551",
  viewBox: "0 0 49.551 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M49.55 23.3H6.588L27.445 2.442 25-.003l-25 24.9 25.05 25.05 2.445-2.495-20.66-20.71H49.55z"
  })]
});